module.exports = __webpack_public_path__ + "img/splitter-east.8a04663e.png";